
define("tpl!lq/dialogs/message.html", ["underscore"], function(_) { return function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="message-layer" class="modal-layer">\r\n    <div class="modal-wrapper">\r\n        <div class="modal-container">\r\n            <div class="modal">\r\n                <header>\r\n                    <h2 id="message-title"></h2>\r\n                </header>\r\n\r\n                <div class="content pre-wrap" id="message-content"></div>\r\n\r\n                <footer>\r\n                    <button class="button blue right" id="message-close">Close</button>\r\n                </footer>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
}
return __p;
};});

